<template>
  <div style="width: 100%">
    <keep-alive>
      <HomeKonectVan v-if="konectVan.state == 'home'" />
      <DetailKonectVan v-if="konectVan.state == 'detail'" />
    </keep-alive>
  </div>
</template>

<script>
import services from "@/utils/services";
import { HomeKonectVan, DetailKonectVan } from "@/components";
import { mapGetters } from "vuex";

export default {
  name: "report",
  components: {
    HomeKonectVan,
    DetailKonectVan,
  },
  data: () => ({
    loading: false,
  }),
  mounted() {},
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
    ...mapGetters("konectVan", ["konectVan"]),
  },
  methods: {},
};
</script>

<style scoped>
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #a4a0a0 !important;
}
</style>
